export const scenariesData = [
  {
    index: 0,
    name: "Tecate Original",
    coords: [
      [25.681909, -100.280323]
    ],
    color: '#EC202B',
    type: 'Escenarios',
  },
  {
    index: 1,
    name: "Tecate Light",
    coords: [
      [25.681335, -100.285656]
    ],
    color: '#2D3192',
    type: 'Escenarios',
  },
  {
    index: 2,
    name: "Sorpresa Viva",
    coords: [
      [25.681938, -100.283940]
    ],
    color: '#00683C',
    type: 'Escenarios',
  },
  {
    index: 3,
    name: "Acústico Hey!",
    coords: [
      [25.678811, -100.284348]
    ],
    color: '#AB7A4D',
    type: 'Escenarios',
  },
  {
    index: 4,
    name: "Club Social Kia",
    coords: [
      [25.679874, -100.282856]
    ],
    color: '#EB008B',
    type: 'Escenarios',
  },
  {
    index: 5,
    name: "Oasis Bacardí",
    coords: [
      [25.678598, -100.280030]
    ],
    color: '#ED8C5C',
    type: 'Escenarios',
  },
  {
    index: 6,
    name: "Villa Maravilla",
    coords: [
      [25.679621, -100.279672]
    ],
    color: '#EB1D23',
    type: 'Escenarios',
  },
  {
    index: 7,
    name: "Hot Nuts Pilo's",
    coords: [
      [25.679751, -100.280992]
    ],
    color: '#8C817B',
    type: 'Escenarios',
  },
  {
    index: 8,
    name: "Fusión Telcel",
    coords: [
      [25.679011, -100.278069]
    ],
    color: '#007DEB',
    type: 'Escenarios',
  }
]
